// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDN-rOa2itHC0puvbPycPAS3JA2_mRaUEA",
  authDomain: "gsp-photos-1fe98.firebaseapp.com",
  projectId: "gsp-photos-1fe98",
  storageBucket: "gsp-photos-1fe98.appspot.com",
  messagingSenderId: "798580465591",
  appId: "1:798580465591:web:a1239d6b5c3c82642d5232",
  measurementId: "G-JZCLN22PLZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage and export
const storage = getStorage(app);
export { storage };
